import { createFileRoute } from "@tanstack/react-router";
import TwoFactorChallenge from "@/ui/components/auth/two-factor";

export const Route = createFileRoute("/_auth/two-factor")({
  component: TwoFactorChallenge,
});
